import { render, staticRenderFns } from "./AuthorizedSignature.vue?vue&type=template&id=59dd5974"
import script from "./AuthorizedSignature.vue?vue&type=script&lang=js"
export * from "./AuthorizedSignature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports